import { useQuery } from '@tanstack/react-query';
import { offlineConversionsApi } from '@/services/api/offlineConversions';

/**
 * Whether the current user can use the offline conversion upload flow.
 *
 * Backed by `/api/v1/offline-conversions/access`, which reads from the
 * backend env-var-driven member_id allowlist. No frontend allowlist to
 * keep in sync.
 *
 * Returns `false` until the query resolves so the dashboard card never
 * flashes briefly before being hidden.
 */
export function useOfflineConversionsAccess(): boolean {
  const query = useQuery({
    queryKey: ['offline-conversions-access'],
    queryFn: offlineConversionsApi.access,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  return query.data ?? false;
}
